import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgressWithLabel from "../CircularProgressBar";
import { useDispatch } from "react-redux";
import * as acts from "../../redux/administrator/actions";
import "./outputTable.scss";

const TableReviewBatch = ({ data }) => {
  const dispatch = useDispatch();
  const [fileNameFilter, setFileNameFilter] = useState("");
  const [drugTypeFilter, setDrugTypeFilter] = useState("");
  const [fileTypeFilter, setFileTypeFilter] = useState("");

  const [debouncedFileName, setDebouncedFileName] = useState("");
  const [debouncedDrugType, setDebouncedDrugType] = useState("");

  // const apiStatus = useSelector((state) => state?.admin?.apiStatus);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedFileName(fileNameFilter);
      setDebouncedDrugType(drugTypeFilter);
    }, 300); // debounce time

    return () => clearTimeout(handler);
  }, [fileNameFilter, drugTypeFilter]);

  const handleDelete = (complitinId) => {
    dispatch(acts.handleDeletePdf(complitinId));
  };

  const fileTypes = useMemo(
    () => [...new Set(data?.map((d) => d.file_type))],
    [data]
  );

  const filteredData = useMemo(() => {
    return data?.filter((item) => {
      const matchesFileName = item.file_name
        .toLowerCase()
        .includes(debouncedFileName.toLowerCase());
      const matchesDrugType = item.drug_type
        .toLowerCase()
        .includes(debouncedDrugType.toLowerCase());
      const matchesFileType =
        !fileTypeFilter || item.file_type === fileTypeFilter;

      return matchesFileName && matchesDrugType && matchesFileType;
    });
  }, [data, debouncedFileName, debouncedDrugType, fileTypeFilter]);

  return (
    <Box className="outputTable-container h-100">
      {/* Filters */}
      <Grid container spacing={2} sx={{ padding: "0px 0px 5px 25px" }}>
        <Grid item xs={6} sm={3}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search by File Name"
            value={fileNameFilter}
            onChange={(e) => setFileNameFilter(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={6} sm={3}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search by Drug Type"
            value={drugTypeFilter}
            onChange={(e) => setDrugTypeFilter(e.target.value)}
          />
        </Grid>

        <Grid item xs={6} sm={2}>
          <Select
            fullWidth
            size="small"
            displayEmpty
            value={fileTypeFilter}
            onChange={(e) => setFileTypeFilter(e.target.value)}
          >
            <MenuItem value="">All File Types</MenuItem>
            {fileTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>

      {/* Table */}
      <Box className="dashboard-wrap-table">
        <TableContainer className="table-container h-100">
          <Table stickyHeader className="table-output" aria-label="table">
            <TableHead>
              <TableRow>
                <TableCell align="center" className="index-cell">
                  Index
                </TableCell>
                <TableCell align="left">File Name</TableCell>
                <TableCell align="left">File Type</TableCell>
                <TableCell align="left">Drug Type</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="left">Created on</TableCell>
                <TableCell align="left">Updated on</TableCell>
                <TableCell align="left">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData?.map((list, index) => (
                <TableRow key={list.id}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="left">{list.file_name}</TableCell>
                  <TableCell align="left">{list.file_type}</TableCell>
                  <TableCell align="left">{list.drug_type}</TableCell>
                  <TableCell align="left">
                    {list.status === "in progress" ? (
                      list.task_failed ? (
                        "Failed"
                      ) : list.completion_status === "100%" ? (
                        "Completed"
                      ) : (
                        <Tooltip title={`Progress: ${list?.completion_status}`}>
                          <Box
                            sx={{
                              width: 100,
                              position: "relative",
                              display: "inline-flex",
                            }}
                          >
                            <CircularProgressWithLabel
                              value={list?.completion_status}
                            />
                          </Box>
                        </Tooltip>
                      )
                    ) : (
                      list.status
                    )}
                  </TableCell>
                  <TableCell align="left">{list?.created_on}</TableCell>
                  <TableCell align="left">{list?.updated_on}</TableCell>
                  <TableCell>
                    <IconButton
                      aria-controls="edit-menu"
                      aria-haspopup="true"
                      onClick={() => handleDelete(list?.client_data_file_id)}
                      disabled={list?.task_failed === false}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {filteredData?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No data found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={message}
          handleClose={() => setSuccess(false)}
        />
      )} */}
      </Box>
    </Box>
  );
};

export default TableReviewBatch;
